import React from 'react';

import {
  Grid,
  Switch,
  Tooltip,
  FormControlLabel,
  makeStyles,
} from '@material-ui/core';
import AutoTooltip from 'components/ExplanationHover';
import styles from './styles';

interface AutoSwitchProps {
  id?: string;
  label: React.ReactNode | string;
  checked: boolean;
  hidden?: boolean;
  explanationHover?: React.ReactNode;
  tooltipTitle?: string;
  disabled?: boolean;
  hover?: string;
  size?: 'small' | 'medium';
  overrideClasses?: any;
  onChange: (e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
}

const AutoSwitch = ({
  id,
  label,
  checked,
  hidden,
  explanationHover,
  tooltipTitle,
  disabled,
  hover,
  size,
  overrideClasses,
  onChange,
}: AutoSwitchProps) => {
  const classes = makeStyles(styles(overrideClasses))();

  return hidden ? null : (
    <Grid container className={classes.switchContainer}>
      <Tooltip
        disableFocusListener={!disabled}
        disableHoverListener={!disabled}
        title={hover}
        arrow
        placement="left"
      >
        <FormControlLabel
          label={label}
          control={
            <Switch
              disabled={disabled}
              id={id}
              checked={checked}
              onChange={onChange}
              size={size}
            />
          }
        />
      </Tooltip>
      {!!tooltipTitle && <AutoTooltip title={tooltipTitle} />}
      {!!explanationHover && explanationHover}
    </Grid>
  );
};

export default AutoSwitch;
